import React, { Fragment } from 'react';

export default {
  title: <Fragment><strong>Lucke</strong><span>-Phase</span></Fragment>,
  duration: 'Februar 2013 - Juli 2015',
  startDate: new Date(2013, 0, 1),
  endDate: new Date(2015, 6, 4),
  description: 'Rechtsliberale Euroskeptiker',
  description_long: 'Die AfD startet als Anti-Euro-Partei - begleitet von einem Mix aus marktliberalen Positionen und restriktiveren Tönen in der Migrationspoltik. Sie bindet Protestwähler an sich und wird bereits in dieser Phase rechts von CDU/CSU verortet.',
  items: [{
    milestone: true,
    coords: {
      x: new Date(2013, 1, 6),
      y: 1.5
    },
    coordsMobile: {
      x: new Date(2013, 1, 6),
      y: 1.5
    },
 	kicker: '6. Februar 2013',
 	title: 'Gründung der AfD',
    text:
      <p>
        Im Gemeindesaal der Christuskirche im hessischen Oberursel treffen sich 18 Männer und gründen die „Alternative für Deutschland“.
        Der Parteiname stammt noch aus dem Vorläufer-Verein „Wahlalternative 2013“ und bezieht sich auf die Äußerung von Bundeskanzlerin Angela Merkel, dass die Euro-Rettung „alternativlos“ sei.
      </p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2013, 3, 13),
      y: 3
    },
    coordsMobile: {
      x: new Date(2013, 3, 13),
      y: 3
    },
    kicker: '13. April 2013',
    title: 'Erster Parteitag',
    text:
      <p>
      <span className="media">
        <img src="images/chronik/1-2013-04_Berlin_Lucke_dpa.jpg"/>
        <span className="media-sub clearfix">
          <span className="media-caption">Lucke auf dem Gründungsparteitag</span>
          <span className="media-credit">dpa/picture alliance</span>
        </span>
      </span>
      Zwei Monate nach der eigentlichen Gründung in Oberursel werden auf dem medienwirksamen Berliner „Gründungsparteitag“ Bernd Lucke, Konrad Adam und Frauke Petry zum Chef-Trio der AfD gewählt
      - und ein Programm für die bevorstehende Bundestagswahl beschlossen.
      Das bestimmende Thema: der Ausstieg aus dem Euro. Volkswirtschaftsprofessor Lucke wird das Gesicht der Anti-Euro-Partei.
      </p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2013, 8, 22),
      y: 5.5
    },
    coordsMobile: {
      x: new Date(2013, 8, 22),
      y: 5.5
    },
    kicker: '22. September 2013',
    title: 'AfD verfehlt knapp Einzug in den Bundestag',
    text:
      <p>
        Die AfD tritt erstmals zur Bundestagswahl und zur am selben Tag stattfindenden Landtagswahl in Hessen an. Den Einzug in die Parlamente verfehlt sie nur knapp mit 4,7 Prozent (Bundestag) und 4,1 Prozent (Hessen).
        Auf eine Kandidatur bei der bayerischen Landtagswahl hatte die Partei eine Woche zuvor noch verzichtet.
        Trotz des Scheiterns an der Fünf-Prozent-Hürde ist das Abschneiden bei der Bundestagswahl ein historischer Erfolg: Es ist das beste Ergebnis einer erst neu gegründeten Partei seit 60 Jahren.
      </p>,
    additional: <p><strong>Bundestagswahl:</strong> 4,7&nbsp;Prozent</p>
  }, {
    milestone: true,
    coords: {
      x: new Date(2014, 4, 25),
      y: 6.9
    },
    coordsMobile: {
      x: new Date(2014, 4, 25),
      y: 6.9
    },
    kicker: '25. Mai 2014',
    title: 'Triumph bei Europawahl - AfD erstmals im Parlament',
    text:
      <p>
        Die AfD schafft zum ersten Mal bei Wahlen den Sprung in ein Parlament: Mit einem Ergebnis von 7,1 Prozent kann sie nach der Europawahl sieben Abgeordnete nach Brüssel entsenden.
        Zum Ende der Legislaturperiode - fünf Jahre später - wird nur noch ein Europa-Abgeordneter AfD-Mitglied sein: der jetztige Co-Parteichef Jörg Meuthen.
        Zeitgleich zur EU-Wahl finden in zehn Bundesländern Kommunalwahlen statt - und viele AfD-Kandidaten verankern sich in den Gemeinden.
      </p>

      ,
      additional: <p><strong>Europawahl:</strong> 7,1&nbsp;Prozent</p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2014, 7, 31),
      y: 7.9
    },
    coordsMobile: {
      x: new Date(2014, 7, 31),
      y: 7.9
    },
    kicker: '31. August 2014',
    title: 'Erfolge im Osten - AfD erobert ersten Landtag',
    text:
      <p>
        Die AfD fasst Fuß in der Landespolitik: Bei der Landtagswahl in Sachsen bekommt die Partei jede zehnte Stimme (9,7 Prozent).
        Zwei Wochen später wird sie mit 10,6 Prozent in den Thüringer Landtag gewählt - und mit 12,2 Prozent in den Brandenburger. Die AfD ist schon 2014 keine ein-Themen-Partei mehr,
        insbesondere im Osten punktet sie auch mit einer restriktiven Einwanderungspolitik.
      </p>,
    additional: <p><strong>Sachsen-Wahl:</strong> 9,7&nbsp;Prozent</p>
  }, /*{
    milestone: false,
    coords: {
      x: new Date(2014, 9, 23),
      y: 7
    },
    coordsMobile: {
      x: new Date(2014, 9, 23),
      y: 7
    },

    kicker: '23. September 2014',
    text:
      <p>
       Nach den Erfolgen bei in drei ostdeutschen Ländern erreicht die AfD auch bei deutschlandweiten Umfragen neue Höhen und kommt bei der Sonntagsfrage zum Bundestag erstmals auf <strong>zehn Prozent</strong> (Forsa).
      </p>
  },*/{
    milestone: false,
    coords: {
      x: new Date(2015, 0, 12),
      y: 5.8
    },
    coordsMobile: {
      x: new Date(2015, 0, 12),
      y: 5.8
    },
    kicker: '12. Januar 2015',
    title: 'Pegida auf dem Höhepunkt',
    text:
      <p>
        <span className="media">
          <img src="images/chronik/1-2015-02__Pegida_Dresden_dpa.jpg"/>
          <span className="media-sub clearfix">
            <span className="media-caption">Pegida-Kundgebung in Dresden</span>
            <span className="media-credit">dpa/picture alliance</span>
          </span>
        </span>
        Rund 25.000 Demonstranten versammeln sich in Dresden bei der bis heute größten Kundgebung der islamfeindlichen Pegida-Bewegung.
        Die AfD ist uneinig über ihr Verhältnis zu Pegida und deren Zielen, ein Richtungsstreit innerhalb der AfD hat längst begonnen.
      </p>
  }, {
    milestone: false,
    coords: {
      x: new Date(2015, 2, 15),
      y: 4.9
    },
    coordsMobile: {
      x: new Date(2015, 2, 15),
      y: 4.9
    },
    title: '„Erfurter Resolution" fordert Kurs nach rechts',
    kicker: '14. März 2015',
    text:
      <p>
        Mit der „Erfurter Resolution“ versuchen AfD-Mitglieder um Björn Höcke (Thüringen) und André Poggenburg (Sachsen-Anhalt),
        die Partei gegen ihren Gründer und Chef Bernd Lucke auf einen rechtskonservativen, nationalistischen Kurs zu bringen. Die rechte Gruppierung nennt sich „Der Flügel“, das Pamphlet gilt heute als seine Gründungsurkunde.
        Nur elf Tage später haben schon 1600 Parteimitglieder die Resolution unterzeichnet. Als einer der ersten ist auch Alexander Gauland dabei.
      </p>
  }]
};